export default __webpack_public_path__ + "static/media/maggot.b74bdc4c.jpg";